import React, { Fragment } from "react";
import AccountDataField from "./data-field";
var AccountInvoices = function AccountInvoices(_ref) {
    var invoices = _ref.invoices;
    if (!invoices || invoices.length < 1) {
        return /*#__PURE__*/ React.createElement("span", null, "Keine Rechnungen vorhanden.");
    }
    return /*#__PURE__*/ React.createElement(Fragment, null, invoices.map(function (invoice, index) {
        var invoiceType = invoice.invoiceType === 'canceled' ? 'storniert' : invoice.invoiceType === 'credit' ? 'Storno-Rechnung / Erstattung' : undefined;
        var notice = (invoiceType ? invoiceType + ", " : "") + "Rechnungsdatum: " + invoice.invoiceDate;
        return /*#__PURE__*/ React.createElement(AccountDataField, {
            name: invoice.invoiceNumber,
            value: "\xBB Rechnung herunterladen",
            notice: notice,
            link: invoice.documentUrl,
            key: index
        });
    }));
};
export default AccountInvoices;
